import { takeLatest, call, put } from 'redux-saga/effects';
import {
    getPatientsSuccess,
    getPatientsFailure,
    resetPasswordSuccess,
    resetPasswordFailure,
    sendResetEmailSuccess,
    sendResetEmailFailure,
    toggleImageAccessSuccess,
    toggleImageAccessFailure,
} from './slice';
import requestHandler from '../../../utils/requestHandler';
import { logoutRequest } from '../auth/authSlice';

function* getPatients(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) {
            yield put(logoutRequest());
            return;
        }
        const { page, limit, searchQuery } = action.payload || { page: 1, limit: 10, searchQuery: "" };
        const requestDetail = {
            method: "GET",
            headers: {
                "Authorization": authToken,
                "Content-Type": "application/json",
            }
        };
        const response = yield call(
            requestHandler,
            `${process.env.REACT_APP_SERVER_API}api/patients?page=${page}&limit=${limit}&searchQuery=${searchQuery}`,
            requestDetail
        );
        yield put(getPatientsSuccess(response));
    } catch (error) {
        yield put(getPatientsFailure(error?.response?.message || error));
    }
}

function* resetPassword(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) {
            yield put(logoutRequest());
            return;
        }

        // Support both simple patientId and object with patientId + manualPassword
        const patientId = typeof action.payload === 'object' ? action.payload.patientId : action.payload;
        const manualPassword = typeof action.payload === 'object' ? action.payload.manualPassword : null;

        const requestDetail = {
            method: "POST",
            headers: {
                "Authorization": authToken,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ manualPassword })
        };
        const response = yield call(
            requestHandler,
            `${process.env.REACT_APP_SERVER_API}api/patient/reset-password/${patientId}`,
            requestDetail
        );
        yield put(resetPasswordSuccess(response));
    } catch (error) {
        yield put(resetPasswordFailure(error?.response?.message || error));
    }
}

function* sendResetEmail(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) {
            yield put(logoutRequest());
            return;
        }
        const requestDetail = {
            method: "POST",
            headers: {
                "Authorization": authToken,
                "Content-Type": "application/json",
            }
        };
        const response = yield call(
            requestHandler,
            `${process.env.REACT_APP_SERVER_API}api/patient/send-reset-email/${action.payload}`,
            requestDetail
        );
        yield put(sendResetEmailSuccess(response));
    } catch (error) {
        yield put(sendResetEmailFailure(error?.response?.message || error));
    }
}

function* toggleImageAccess(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) {
            yield put(logoutRequest());
            return;
        }
        const { patientId, canViewImages } = action.payload;
        const requestDetail = {
            method: "PUT",
            headers: {
                "Authorization": authToken,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ canViewImages })
        };
        const response = yield call(
            requestHandler,
            `${process.env.REACT_APP_SERVER_API}api/patient/toggle-image-access/${patientId}`,
            requestDetail
        );
        yield put(toggleImageAccessSuccess({ ...response, patientId, canViewImages }));
    } catch (error) {
        yield put(toggleImageAccessFailure(error?.response?.message || error));
    }
}

function* saga() {
    yield takeLatest('patients/getPatientsRequest', getPatients);
    yield takeLatest('patients/resetPasswordRequest', resetPassword);
    yield takeLatest('patients/sendResetEmailRequest', sendResetEmail);
    yield takeLatest('patients/toggleImageAccessRequest', toggleImageAccess);
}

export default saga;
